import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        // primary: '#587B7F', //coolors ming
        // primary: '#607d8b', // vuetify blue-grey
        // primary: '#F24C00', //coolors international orange aerospace
        primary: '#F2AF29', //coolors honey yellow
        secondary: '#607d8b', // vuetify blue-grey
        success: '#558B2F',
        anchor: '#eee',
        weekly_scores: '#7FFF00',
        league: '#FFFF00',
        sd: 'FF0000',
        danger: 'B22222',

        //DEFAULTS
        // primary: '#1976D2',
        // secondary: '#424242',
        // accent: '#82B1FF',
        // error: '#FF5252',
        // info: '#2196F3',
        // success: '#4CAF50',
        // warning: '#FFC107',
      }
    }
  }
});
